import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const postingHistoryApi = {
  getAll: (params?: { teacherName?: string; district?: string; page?: number; limit?: number }) => {
    return api.get('/posting-histories', { params })
  },
  getByTeacher: (teacherId: number, params?: { page?: number; limit?: number }) => {
    return api.get(`/posting-histories/teacher/${teacherId}`, { params })
  },
  getAllAttachments: (params?: { teacherName?: string; district?: string; page?: number; limit?: number }) => {
    return api.get('/posting-histories/attachments', { params })
  },
  getAllDeputations: (params?: { teacherName?: string; district?: string; page?: number; limit?: number }) => {
    return api.get('/posting-histories/deputations', { params })
  },
  exportPostingHistoriesExcel: (params?: { teacherName?: string; district?: string }) => {
    return api.get('/posting-histories/export/excel', { params, responseType: 'blob' })
  },
  exportAttachmentsExcel: (params?: { teacherName?: string; district?: string }) => {
    return api.get('/posting-histories/attachments/export/excel', { params, responseType: 'blob' })
  },
  exportDeputationsExcel: (params?: { teacherName?: string; district?: string }) => {
    return api.get('/posting-histories/deputations/export/excel', { params, responseType: 'blob' })
  },
  exportAllExcel: (params?: { teacherName?: string; district?: string }) => {
    return api.get('/posting-histories/export/all/excel', { params, responseType: 'blob' })
  },
  exportSelfPostingHistoriesExcel: () => {
    return api.get('/posting-histories/self/export/postings/excel', { responseType: 'blob' })
  },
  exportSelfAttachmentsExcel: () => {
    return api.get('/posting-histories/self/export/attachments/excel', { responseType: 'blob' })
  },
  exportSelfDeputationsExcel: () => {
    return api.get('/posting-histories/self/export/deputations/excel', { responseType: 'blob' })
  },
  exportSelfAllExcel: () => {
    return api.get('/posting-histories/self/export/all/excel', { responseType: 'blob' })
  },
  getPostingOfficers: () => {
    return api.get('/posting-histories/officers')
  },
  submitMyPostingHistory: (data: { has_no_posting_history: boolean; posting_histories: any[]; target_office: string; target_officer_role?: string }) => {
    return api.post('/posting-histories/my-submission', data)
  },
  getMyPostingHistoryStatus: () => {
    return api.get('/posting-histories/my-status')
  },
  getPendingPostingHistoryRequests: (params?: { page?: number; limit?: number }) => {
    return api.get('/posting-histories/requests/pending', { params })
  },
  approvePostingHistoryRequest: (id: number, data?: { target_deo?: string; target_office?: string; remarks?: string }) => {
    return api.post(`/posting-histories/requests/${id}/approve`, data)
  },
  rejectPostingHistoryRequest: (id: number, remarks: string) => {
    return api.post(`/posting-histories/requests/${id}/reject`, { remarks })
  },
  forwardPostingHistoryRequest: (id: number, data: { forward_to_office: string; forward_to_role?: string; remarks?: string }) => {
    return api.post(`/posting-histories/requests/${id}/forward`, data)
  }
}

